import React from 'react'
import { Route, Routes } from 'react-router-dom'
import SignUp from '../pages/SignUp'
import { SignIn } from '../pages/SignIn'
import { Youtube } from '../pages/Youtube'
import { Video } from 'pages/product-video-editor'
import { Terms } from '../pages/Terms'
import { MyPayments } from '../pages/MyPayments'

import { QnA } from '../pages/QnA'
import { PaymentFail } from '../pages/payment/components/PaymentFail'
import { MyCashDashboard } from 'pages/MyCashDashboard'
import { ContentVideo } from 'pages/content-video-editor'
import { MyPage } from '../pages/MyPage'
import { CouponPack } from '../pages/CouponPack'
import { Challenge } from 'pages/Challenge'
import { CancelSubscription } from '../pages/CancelSubscription'
import { ShortFormPriceGuide } from '../pages/price-guide/ShortFormPriceGuide'
import { Subscription } from '../pages/Subscription'

import { CancelSubscriptionConfirm } from '../pages/CancelSubscriptionConfirm'
import Home from 'pages/Home'
import { GlobalPage } from 'pages/global'
import { PriceGuide } from 'pages/price-guide/PriceGuide'
import { VideoUsageHistory } from 'pages/video-usage-history'
import { PaymentSuccess } from 'pages/payment/components/PaymentSuccess'
import { AIStudio } from 'pages/ai-studio'
import { StyleRoomPriceGuide } from 'pages/price-guide/StyleRoomPriceGuide'
import classNames from 'classnames'
import { isMobile } from 'react-device-detect'
import { useAuthHeader } from 'hooks/header/useAuthHeader'
import { AI } from 'pages/ai'
import { Anonymous } from 'pages/anonymous'

export const AppRouter: React.FC = () => {
  const { currentPath } = useAuthHeader()
  return (
    <div
      className={classNames('', {
        'pt-40':
          currentPath !== '/my-page' &&
          currentPath !== '/challenge' &&
          currentPath !== '/ai' &&
          !currentPath.includes('ai-studio') &&
          !isMobile,

        'pt-32':
          (currentPath === '/my-page' || currentPath === '/challenge') &&
          !isMobile,
        'pt-[101px]': currentPath.includes('ai-studio') && !isMobile,
        'pt-[100px]': currentPath.includes('/ai/create') && !isMobile,
      })}
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ai-studio/*" element={<AIStudio />} />
        <Route path="/ai/*" element={<AI />} />
        <Route path="/video-editor" element={<Video />} />
        <Route path="/short-video-editor" element={<ContentVideo />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/my-payments" element={<MyPayments />} />
        <Route path="/youtube-auth" element={<Youtube />} />
        <Route path="/cancel-subscription" element={<CancelSubscription />} />
        <Route
          path="/cancel-subscription-confirm"
          element={<CancelSubscriptionConfirm />}
        />
        <Route path="/QnA" element={<QnA />} />
        <Route path="/global" element={<GlobalPage />} />
        <Route path="/my-page" element={<MyPage />} />
        <Route path="/my-videos" element={<VideoUsageHistory />} />
        <Route path="/payment-fail" element={<PaymentFail />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/price-guide" element={<PriceGuide />} />
        <Route
          path="/shortform-price-guide"
          element={<ShortFormPriceGuide />}
        />
        <Route path="/price/style-room" element={<StyleRoomPriceGuide />} />
        <Route path="/my-cash-dashboard" element={<MyCashDashboard />} />
        <Route path="/coupon-pack" element={<CouponPack />} />
        <Route path="/challenge" element={<Challenge />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/anonymous/*" element={<Anonymous />} />
        <Route path="/*" element={<Home />} />
      </Routes>
    </div>
  )
}
